import React from "react";
import { Download } from "lucide-react";
import { usePwaInstall } from "@/lib/pwa";

// "Installer l'application" — surfaces the PWA install prompt (Chrome/Edge/Android)
// or iOS "Add to Home Screen" guidance. Hidden once the app is already installed.
export const InstallAppButton = ({ className = "" }) => {
  const { canInstall, promptInstall } = usePwaInstall();
  if (!canInstall) return null;

  return (
    <button
      onClick={promptInstall}
      data-testid="install-app-btn"
      title="Installer IMPERIUM comme application"
      className={`flex items-center gap-2 px-3 md:px-4 h-10 rounded-sm border border-aurora-cyan/40 text-aurora-cyan bg-aurora-cyan/5 hover:bg-aurora-cyan/15 transition-colors font-display uppercase tracking-wide text-xs ${className}`}
    >
      <Download className="w-4 h-4" />
      <span className="hidden sm:inline">Installer l'app</span>
    </button>
  );
};
